// extracted by mini-css-extract-plugin
export var footerNav = "footer-module--footer-nav--Nmfvq";
export var navBlock = "footer-module--nav-block--YOjNF";
export var footerEnvelop = "footer-module--footer-envelop--KjzEP";
export var contactSocial = "footer-module--contact-social--F39XL";
export var followUs = "footer-module--follow-us--IBviZ";